module.exports = __webpack_public_path__ + "img/preguntas-frecuentes.fcfa61ea.webp";